export const META_CUSTOM_AUDIENCE_SCOPES =
    "email,ads_management,ads_read,business_management,pages_manage_ads,manage_business_extension,pages_read_engagement";
